import {Card, CardContent, Stack, Typography, Chip, LinearProgress, CardHeader, IconButton} from "@mui/material";
import {FiberManualRecord, Flag, MoreVert} from "@mui/icons-material";
import {CircularProgressbar, buildStyles} from "react-circular-progressbar";
import {dashboardHelper} from "../utils/dashboardHelper";
import TourneeStatutBadge from "./TourneeStatutBadge";
import Constants from "../../../../utils/constants";
import {useTheme} from "@mui/material/styles";
import {helper} from "../../../../utils/helper";
import BadgeTypeLavage from "../../layout/BadgeTypeLavage.js";

function TourneeCard({
                         data,
                         selectedDate,
                         onMenuClick,
                         onTourneeDetailClick,
                         onTourneeImpossibleClick,
                         withHeader = false,
                         withProductivite = false
                     }) {
    return (
        <Card>
            {withHeader &&
                <CardHeader
                    className={"tourneecard-header"}
                    subheader={[
                        data.libelle,
                        dashboardHelper.formatHeureDebut(data.heureDebut) && `Début ${dashboardHelper.formatHeureDebut(data.heureDebut)}`,
                        `${data.totalALaver} bacs`,
                    ].filter(Boolean).join(' - ')}
                    action={onMenuClick && (
                        <IconButton onClick={onMenuClick}>
                            <MoreVert sx={{color: "white"}}/>
                        </IconButton>
                    )}
                    slotProps={{
                        subheader: {
                            sx: {
                                color: 'white',
                                textAlign: 'center'
                            }
                        }
                    }}
                />
            }
            {data.lavagePartiel && (
                <div className="tourneecard-lavage-partiel-ribbon">
                    Lavage Partiel: {data.prestationLavagePartiel}
                </div>
            )}

            <CardContent>
                <Stack direction="column" spacing={1}>
                    <Stack direction="row" spacing={2} justifyContent="center">
                        <TourneeStatutBadge
                            totalALaver={data.totalALaver}
                            totalBacsLaves={data.totalBacsLaves}
                            totalBacsImpossible={data.totalBacsImpossible}
                        />
                        <BadgeTypeLavage type={data.type}/>
                    </Stack>

                    <Stack direction="row" spacing={1}
                           sx={{padding: '1rem 1rem', cursor: "pointer"}} justifyContent="space-evenly">
                        <div onClick={onTourneeDetailClick} className={"tournee-circular-progressbar-wrapper"}>
                            <CircularProgressbar
                                className={"tournee-circular-progressbar"}
                                value={Math.round((data.totalBacsLaves / data.totalALaver) * 100)}
                                text={data.totalBacsLaves + " lavé(s)"}
                                styles={buildStyles({
                                    textSize: '12px',
                                    textColor: Constants.COLOR_THEME_GREEN,
                                    pathColor: Constants.COLOR_THEME_GREEN
                                })}
                            />
                        </div>
                        <div onClick={onTourneeImpossibleClick} className={"tournee-circular-progressbar-wrapper"}>
                            <CircularProgressbar
                                className={"tournee-circular-progressbar"}
                                value={Math.round((data.totalBacsImpossible / data.totalALaver) * 100)}
                                text={data.totalBacsImpossible + " impossible(s)"}
                                styles={buildStyles({
                                    textSize: '12px',
                                    textColor: Constants.COLOR_THEME_RED,
                                    pathColor: Constants.COLOR_THEME_RED
                                })}
                            />
                        </div>
                        {withProductivite && (
                            <div className={"tournee-circular-progressbar-wrapper"}>
                                <CircularProgressbar
                                    className={"tournee-circular-progressbar"}
                                    value={data.productivite * 10}
                                    text={`${data.productivite} Bacs/h`}
                                    styles={buildStyles({
                                        textSize: '12px',
                                        textColor: dashboardHelper.getProductiviteColor(data.productivite),
                                        pathColor: dashboardHelper.getProductiviteColor(data.productivite),
                                    })}
                                />
                            </div>
                        )}
                    </Stack>

                    <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                        <Stack direction="row" alignItems="center">
                            <FiberManualRecord/>
                            <Typography variant="body1">
                                {helper.getFormattedTime(data.dateDebut)}
                            </Typography>
                        </Stack>

                        <div className="line"></div>

                        <Stack direction="row" alignItems="center">
                            <Typography variant="body1">
                                {helper.getFormattedTime(data.dateFin)}
                            </Typography>
                            <Flag/>
                        </Stack>
                    </Stack>

                    <Stack direction="row" justifyContent="center">
                        <Typography variant="body1">
                            {dashboardHelper.getDuration(data.dateDebut, data.dateFin)}
                        </Typography>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}

export default TourneeCard;
